import { render, staticRenderFns } from "./ChatEditor2.vue?vue&type=template&id=053cf3eb&scoped=true&"
import script from "./ChatEditor2.vue?vue&type=script&lang=js&"
export * from "./ChatEditor2.vue?vue&type=script&lang=js&"
import style0 from "./ChatEditor2.vue?vue&type=style&index=0&id=053cf3eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053cf3eb",
  null
  
)

export default component.exports